import { FC } from 'react';
import { CardItem } from '../types';

interface NFTCardProps {
  card: CardItem;
}

const NFTCard: FC<NFTCardProps> = ({ card }) => {
  function getStars(tier: number): JSX.Element {
    if (tier <= 5) {
      return (
        <div>
          {[...Array(tier - 1)].map((_, index) => (
            <span className="star" key={index}>★</span>
          ))}
          {[...Array(5 - tier)].map((_, index) => (
            <span className="star" key={`empty-${index}`}>☆</span>
          ))}
        </div>
      );
    }
    return (
      <div>
        {[...Array(tier - 5)].map((_, index) => (
          <span className="star star-gold" key={index}>★</span>
        ))}
        {[...Array(7 - tier)].map((_, index) => (
          <span className="star star-gold" key={`empty-${index}`}>☆</span>
        ))}
      </div>
    );
  }

  function getPlaneInfo(card: CardItem): string {
    if (card.cat === 1) {
      return 'Collectible';
    } else if (card.cat === 2) {
      return 'Airdrop ' + card.force + ' Year/day';
    } else if (card.cat === 3) {
      return 'Power +' + card.force;
    } else if (card.cat === 4) {
      const yieldValue = Math.pow(5, card.tier - 2);
      return 'Yield +' + yieldValue;
    } else if (card.cat === 5) {
      return 'Jackpot';
    } else if (card.cat === 9) {
      return 'Mystery';
    }
    return '';
  }

  return (
    <div className={`nft-card-img-outer nft-card-cat-${card.cat}`}>
      <div className="nft-card-img-inner">
        <img src={card.img} className="card-img-top" alt="" />
      </div>
      <div className="nft-card-img-text">
        {getPlaneInfo(card)}
        {getStars(card.tier)}
      </div>
    </div>
  );
};

export default NFTCard;
